<script>
export default {
  name: 'PlayerComponent',
  props: ['ppPlayerRef', 'config'],
  methods: {
    initPlayer (ppPlayerRef) {},
    disposePlayer (ppPlayerRef) {}
  },
  watch: {
    ppPlayerRef (value) {
      if (this.ppPlayerRef) {
        this.disposePlayer(this.ppPlayerRef);
      }
      this.ppPlayerRef = value;
      if (this.ppPlayerRef) {
        this.initPlayer(this.ppPlayerRef);
      }
    }
  },
  beforeDestroy () {
    if (this.ppPlayerRef) {
      this.disposePlayer(this.ppPlayerRef);
    }
  },
  created () {
    if (this.ppPlayerRef) {
      this.initPlayer(this.ppPlayerRef);
    }
  }
};
</script>
